import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g transform="scale(1.5 1.5) translate(0 1)">
    <rect fill={fill} />
    <path
      d="M11.0065 0.699219H3.30636C3.04062 0.699219 2.8252 0.914643 2.8252 1.18038V3.32422L7.2877 4.63672L11.4877 3.32422V1.18038C11.4877 0.914643 11.2723 0.699219 11.0065 0.699219Z"
      fill="#41A5EE"
    />
    <path
      d="M11.4877 3.32422H2.8252V5.94922L7.2877 6.73672L11.4877 5.94922V3.32422Z"
      fill="#2B7CD3"
    />
    <path
      d="M2.8252 5.94922V8.57422L7.0252 9.09922L11.4877 8.57422V5.94922H2.8252Z"
      fill="#185ABD"
    />
    <path
      d="M3.30636 11.1992H11.0065C11.2723 11.1992 11.4877 10.9838 11.4877 10.7181V8.57422H2.8252V10.7181C2.8252 10.9838 3.04062 11.1992 3.30636 11.1992Z"
      fill="#103F91"
    />
    <path
      opacity="0.1"
      d="M6.01903 2.79883H2.8252V9.36133H6.01903C6.28441 9.36047 6.49933 9.14555 6.5002 8.88017V3.27999C6.49933 3.01461 6.28441 2.79969 6.01903 2.79883Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M5.75653 3.0625H2.8252V9.625H5.75653C6.02191 9.62414 6.23683 9.40922 6.2377 9.14384V3.54366C6.23683 3.27828 6.02191 3.06336 5.75653 3.0625Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M5.75653 3.0625H2.8252V9.1H5.75653C6.02191 9.09914 6.23683 8.88422 6.2377 8.61884V3.54366C6.23683 3.27828 6.02191 3.06336 5.75653 3.0625Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M5.49403 3.0625H2.8252V9.1H5.49403C5.75941 9.09914 5.97433 8.88422 5.9752 8.61884V3.54366C5.97433 3.27828 5.75941 3.06336 5.49403 3.0625Z"
      fill="black"
    />
    <path
      d="M0.681359 3.0625H5.49403C5.75977 3.0625 5.9752 3.27792 5.9752 3.54366V8.35634C5.9752 8.62208 5.75977 8.83751 5.49403 8.83751H0.681359C0.415619 8.83751 0.200195 8.62208 0.200195 8.35634V3.54366C0.200195 3.27792 0.415619 3.0625 0.681359 3.0625Z"
      fill="url(#paint0_linear_1808_68838)"
    />
    <path
      d="M2.17475 6.75252C2.1842 6.8268 2.1905 6.89138 2.19339 6.94677H2.20441C2.20861 6.89427 2.21736 6.831 2.23066 6.75698C2.24396 6.68295 2.25595 6.62039 2.26662 6.56929L2.77272 4.38582H3.42714L3.95214 6.53648C3.98264 6.67021 4.00447 6.80576 4.0175 6.9423H4.02616C4.03595 6.81002 4.05419 6.6785 4.08077 6.54855L4.49945 4.38477H5.09507L4.35954 7.51377H3.66365L3.1649 5.44159C3.15046 5.382 3.13393 5.30404 3.11581 5.20822C3.0977 5.11241 3.08641 5.04232 3.08195 4.99822H3.07329C3.06751 5.04915 3.05622 5.12475 3.03942 5.22502C3.02262 5.3253 3.00915 5.3995 2.99899 5.44762L2.53017 7.51324H1.82247L1.08301 4.38581H1.68938L2.14534 6.57375C2.15559 6.61864 2.1653 6.67849 2.17475 6.75252Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1808_68838"
        x1="1.20343"
        y1="2.68653"
        x2="4.97196"
        y2="9.21347"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2368C4" />
        <stop offset="0.5" stopColor="#1A5DBE" />
        <stop offset="1" stopColor="#1146AC" />
      </linearGradient>
    </defs>
  </g>
);

export default Icon;
